import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    columnGap: "10rem",
    rowGap: "3rem",
    marginBottom: "3rem",
    padding: "0 1rem",
    paddingTop: "3rem",
    fontSize: "0.8rem",
    color: theme.darkSlateGrayColor,
  },
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    height: "3rem",
    marginLeft: "2rem",
    fontSize: "1rem",
    color: "unset",
    textDecoration: "none",
  },
  subContainer: {
    flexGrow: 1,
    width: "36rem",
    display: "flex",
    flexDirection: "column",
    rowGap: "2rem",
  },
  orderNumber: {
    textTransform: "uppercase",
  },
  thankYouForOrder: {
    color: theme.blackColor,
    textTransform: "uppercase",
    fontSize: "1.4rem",
    fontWeight: 500,
  },
  sectionContainer: {
    border: `1px solid ${theme.lighterSnowColor}`,
    borderRadius: "10px",
    overflow: "hidden",
  },
  sectionTitle: {
    padding: "1rem",
    borderBottom: `1px solid ${theme.lighterSnowColor}`,
  },
  orderUpdates: {
    textTransform: "uppercase",
    borderBottom: "none",
    paddingBottom: 0,
  },
  sectionContent: {
    padding: "1rem",
    fontFamily: theme.fontFamilyQuestrial,
  },
  email: {
    color: theme.lightCoralColor,
  },
  sectionContentCotainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    padding: "1rem",
  },
  subSectionContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    "&:not(:last-child)": {
      paddingBottom: "1rem",
      borderBottom: `1px solid ${theme.darkestWhiteSmokeColor}`,
    },
  },
  subSectionTitle: {
    textTransform: "uppercase",
  },
  subSectionContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.3rem",
    fontFamily: theme.fontFamilyQuestrial,
  },
  btnContainer: {
    display: "flex",
  },
  continueBtn: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3.5rem",
    width: props.matches ? "50%" : "100%",
    padding: 0,
    border: "none",
    borderRadius: "7px",
    marginLeft: "auto",
    textDecoration: "none",
    color: theme.whiteColor,
    background: `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: "uppercase",
    fontSize: "0.9rem",
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor: "pointer",
  }),
}));

export default useStyles;
